import React,{useEffect} from 'react';
import Careers from '../components/Careers';
import { MetaTagsComp } from '../components/MetaTagsComp';
import { GetStaticProps, NextPage } from 'next';
import fetchUtil from '../utils/fetchUtil';

const CareerKC: NextPage = (props:any) => {
  const { meta }= props.pageData;
  useEffect(() => {
    const customStyle = document.documentElement.style;
    customStyle.setProperty("--navbar-color", "#1e1553e3");
    customStyle.setProperty("--navbar-menu-color", "#ffffff");
    customStyle.setProperty("--top-margin", "0");
  }, []);
  return (
    <>
    {meta && <MetaTagsComp {...meta}/>}
      <Careers  {...props}/>
    </>
  )
}

export const getStaticProps: GetStaticProps = async(context)=>{
  const pageData = await fetchUtil(
    `${process.env.NEXT_PUBLIC_API_BASE_URL}/career-page`,
    "GET",
    {},
    "",
    false
  );
  const homePageData = await fetchUtil(
    `${process.env.NEXT_PUBLIC_API_BASE_URL}/home`,
    "GET",
    {},
    "",
    false
  );
  
  return {
    props: {
      pageData,
      homePageData,
    },
  };
}


export default CareerKC;